import request from '@/utils/request'
/**
 * 获取快速添加商品列表
 * @param {*} data
 * @returns
 */
export function getFastAddGoodsList(data) {
  return request({
    url: `/mg/daohang-product-api/goodsCache/listFast`,
    method: 'post',
    data,
  })
}

/**
 * 获取添加商品列表(抽屉)
 * @param {*} data
 * @returns
 */
export function getAddGoodsList(data) {
  return request({
    url: `/mg/daohang-product-api/goodsCache/page`,
    method: 'post',
    data,
  })
}
/**
 * 查询商品列表（不分页）
 * @param {*} data
 * @returns
 */
export function getGoodsList(data) {
  return request({
    url: `/mg/daohang-product-api/goodsCache/list`,
    method: 'post',
    data,
  })
}

/**
 * 可用库存：
 * 该往来单位下, 所有经营组织, 所有可用仓中该商品的可用库存合计值
 */
export function availableStockByPartner(data) {
  return request({
    url: '/mg/daohang-stock-api/kcStorage/partnerStoragelist',
    method: 'post',
    data,
  })
}

/**
 * 包装换算
 * @param {*} data
 * @returns
 */
export function packageConvert(data) {
  return request({
    url: '/mg/daohang-product-api/goodsCache/packageConvert',
    method: 'post',
    data,
  })
}

/**
 * 可用库存
 * 根据仓库编码和商品编码批量查询
 * @param {*} data
 * @returns
 */
export function availableStockByWarehouse(data, loading = true) {
  return request({
    url: '/mg/daohang-stock-api/kcStorage/list',
    method: 'post',
    data,
    loading,
  })
}

/**
 * 根据传参 code 获取导航字典表中的枚举值
 * @param {*} data
 * @returns
 */
export function dictItems(data) {
  return request({
    url: '/mg/daohang-basic-api/dictItem/list',
    method: 'post',
    data,
  })
}

/**
 * 品牌列表
 * @param {*} data
 * @returns
 */
export function getBrandCommonList(data) {
  return request({
    url: '/mg/daohang-product-api/brand/list',
    method: 'post',
    data,
  })
}

/**
 * 品类树
 * @param {*} params
 * @returns
 */
export function getCategoryListTree(params) {
  return request({
    url: '/mg/daohang-product-api/category/tree',
    method: 'get',
    params,
  })
}
/**
 * 交接班详情
 * @returns
 */
export function getShiftHandoverDetail() {
  return request({
    url: '/mg/daohang-basic-api/shiftHandover/detail',
    method: 'get',
  })
}
/**
 * 交接班登出
 * @returns
 */
export function shiftHandoverLoginOut() {
  return request({
    url: '/mg/daohang-basic-api/shiftHandover/loginOut',
    method: 'post',
  })
}

/**
 * 获取热销商品
 */

export function hotSellGoods(data) {
  return request({
    url: '/mg/daohang-product-api/goodsCache/latestSku/list',
    method: 'post',
    data,
  })
}

/**
 * 重置获取热销商品的设备限制
 */
export function resetHotSellLimit() {
  return request({
    url: '/mg/daohang-product-api/goodsCache/latestSku/cleanCache',
    method: 'delete',
  })
}

/**
 * 获取登录门店所有包含当前时间的促销活动
 */
export function allActivePromotions(data) {
  return request({
    url: '/mg/daohang-promotion-api/promotion/getAllPromotionInfo',
    method: 'post',
    data,
  })
}

/**
 * 标准商品库搜索通用接口1
 * @param {*} data
 * @returns
 */
export function findByQuery(data) {
  return request({
    url: '/mg/daohang-product-api/standardGoods/findByQuery',
    method: 'post',
    data,
  })
}

